import { Box } from '@mui/material'
import React from 'react'
import { useNotificationContext } from '../../Context/NotificationContext'
import { NotificationBannerAlert } from './NotificationBannerAlert'

/** Moved to provide a preview. I'm not sure it's worth it's own file. */

export const NotificationBanner: React.FC = () => {
  const { userNotifications } = useNotificationContext()

  const userNotificationAlerts = userNotifications?.map(
    (userNotification, index) => {
      return (
        <NotificationBannerAlert
          key={index}
          userNotification={userNotification}
        />
      )
    }
  )

  return (
    <Box
      display="flex"
      sx={{
        width: '100%',
        flexDirection: 'column',
      }}
    >
      {userNotificationAlerts}
    </Box>
  )
}
